import { useState, useRef, useEffect, useCallback } from 'react'
import axios from 'axios'
import api from '../../../api'
import { socket, reconnectSocket, disconnectSocket } from '../../../Socket'

export function useIdleDisconnect(roomId: string | undefined) {
    const API = process.env.REACT_APP_API_URL;
    const clientId = localStorage.getItem('flashroom_id');

    const resumingRef = useRef(false);

    function waitForSocketConnect() {
        if (socket.connected) return Promise.resolve();

        return new Promise<void>((resolve) => {
            socket.once("connect", () => resolve());
        });
    }

    const rejoinSocket = async () => {
        reconnectSocket();
        await waitForSocketConnect();
        await api.patch(`/rooms/${roomId}/members/${clientId}/rejoin`);
        localStorage.removeItem("flashroom_idle_disconnected");
    };

    const [, setIdle] = useState(false);
    const [idleTimeout, setIdleTimout] = useState(false);

    const idleTimeoutRef = useRef(false);

    useEffect(() => {
        idleTimeoutRef.current = idleTimeout;
    }, [idleTimeout]);

    const timeoutId = useRef<ReturnType<typeof setTimeout> | null>(null);

    async function disconnect() {
        try {
            localStorage.setItem("flashroom_most_recent", roomId!);
            localStorage.setItem("flashroom_idle_disconnected", "true");

            await setMemberInactive();
            setIdle(true);
            setIdleTimout(true);
            disconnectSocket("inactivity");
        } catch (e) {
        }
    }

    function startTimer() {
        if (timeoutId.current) clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(disconnect, 1800000);

        //1800000
    }

    function clearTimer() {
        if (timeoutId.current) clearTimeout(timeoutId.current);
        timeoutId.current = null;
    }

    const changeIdleClick = useCallback(async () => {
        if (idleTimeoutRef.current) {
            if (resumingRef.current) return;
            resumingRef.current = true;

            try {
                await rejoinSocket();
                setIdle(false);
                setIdleTimout(false);
            } catch (e) {
            } finally {
                resumingRef.current = false;
            }
        }

        clearTimer();
        startTimer();
    }, [rejoinSocket]);

    async function setMemberInactive() {

        await axios.patch(`${API}/api/rooms/${roomId}/members/${clientId}/disconnect`)
    }

    useEffect(() => {
        const events: (keyof WindowEventMap)[] = [
            "click",
            "mousemove",
            "keydown",
            "touchstart",
            "focus"
        ];

        const handleActivity = () => {
            changeIdleClick();
        };

        startTimer();

        events.forEach((event) => {
            window.addEventListener(event, handleActivity);
        });

        const handleScroll = () => changeIdleClick();
        window.addEventListener("scroll", handleScroll, true);

        return () => {
            events.forEach((event) => {
                window.removeEventListener(event, handleActivity);
            });
            window.removeEventListener("scroll", handleScroll, true);
            clearTimer();
        };
    }, [changeIdleClick]);
}
